
document.addEventListener('DOMContentLoaded', async function () {

  const resultsContainer =
    document.querySelector('.kb-tech-results');

  const alphabetButtons =
    document.querySelectorAll('.kb-letter-btn');

  const searchInput =
    document.getElementById('kbTechnicalSearch');

  const suggestionsContainer =
    document.querySelector('.kb-tech-search-suggestions');

  let allProducts = [];

  /* ===================================
     CLEAN TEXT
  =================================== */

  function cleanText(text) {

    if (!text) return '';

    return text
      .replace(/&amp;/gi, '&')
      .replace(/\s+/g, ' ')
      .trim();

  }

  /* ===================================
     TECHNICAL CHECK
  =================================== */

  function isTechnicalName(name) {

    return /(%\s?(SC|EC|SL|WG|WP|SP|WSG|OD|ZC|GR))/i.test(name);

  }

  /* ===================================
     LOAD PRODUCTS
  =================================== */

  async function loadProducts() {

    try {

      resultsContainer.innerHTML = `

        <div class="kb-empty-state">
          Loading technical products...
        </div>

      `;

      let allFetchedProducts = [];
      let page = 1;
      let hasMore = true;

      /* FETCH ALL PRODUCTS */

      while (hasMore) {

        const response =
          await fetch(
            `/products.json?limit=250&page=${page}`
          );

        const data =
          await response.json();

        if (data.products.length > 0) {

          allFetchedProducts =
            allFetchedProducts.concat(
              data.products
            );

          page++;

        } else {

          hasMore = false;

        }

      }

      const groupedProducts = {};

      allFetchedProducts.forEach(product => {

        const title =
          cleanText(product.title);

        let technicalName =
          title
            .replace(/krishikranti/gi, '')
            .replace(/krishi bhandar/gi, '')
            .replace(/\(\s*1\+1\s*free\s*\)/gi, '')
            .replace(/\|\s*/g, ' ')
            .trim();

        /* TECHNICAL EXTRACTION */

        const technicalMatch =
          technicalName.match(
            /([A-Za-z0-9\s\.\+\-%]+%\s?(SC|EC|SL|WG|WP|SP|WSG|OD|ZC|GR))/i
          );

        if (technicalMatch) {

          technicalName =
            cleanText(
              technicalMatch[0]
            );

        }

        technicalName =
          cleanText(technicalName);

        if (
          technicalName.length < 3
        ) {
          return;
        }

        /* GROUP */

        if (
          !groupedProducts[technicalName]
        ) {

          groupedProducts[
            technicalName
          ] = [];

        }

        /* DUPLICATE REMOVE */

        const exists =
          groupedProducts[
            technicalName
          ].some(
            p => p.title === title
          );

        if (!exists) {

          groupedProducts[
            technicalName
          ].push({

            title: title,

            image:
              product.images?.[0]?.src || '',

            url:
              '/products/' + product.handle

          });

        }

      });

      /* CONVERT */

      allProducts =
        Object.keys(groupedProducts)
          .map(key => ({

            technicalName: key,

            products:
              groupedProducts[key]

          }));

      /* SORT */

      allProducts.sort((a, b) => {

        const aTech =
          isTechnicalName(
            a.technicalName
          );

        const bTech =
          isTechnicalName(
            b.technicalName
          );

        if (aTech && !bTech) {
          return -1;
        }

        if (!aTech && bTech) {
          return 1;
        }

        return a.technicalName.localeCompare(
          b.technicalName
        );

      });

      renderProducts(allProducts);

    } catch (error) {

      console.log(
        'Technical Search Error',
        error
      );

      resultsContainer.innerHTML = `

        <div class="kb-empty-state">
          Failed to load products
        </div>

      `;

    }

  }

  /* ===================================
     RENDER PRODUCTS
  =================================== */
  resultsContainer.classList.add('loading');
  function renderProducts(groups) {

    if (!groups.length) {

      resultsContainer.innerHTML = `

        <div class="kb-empty-state">
          No technical products found
        </div>

      `;

      return;
    }

    let html = '';

    html += `

<div class="kb-results-bar">

  ${groups.length} Products Found ↓

</div>

`;

    groups.forEach((group, index) => {

      const visibleProducts =
        group.products.slice(0, 5);

      const hiddenProducts =
        group.products.slice(5);

      html += `

        <div class="kb-tech-group">

          <div class="kb-tech-group-header">

            <div class="kb-tech-group-title">
              ${group.technicalName}
            </div>

            <div class="kb-tech-count">
              ${group.products.length}
            </div>

          </div>

          <div class="kb-tech-scroll">

      `;

      visibleProducts.forEach(product => {

        html += renderCard(product);

      });

      if (hiddenProducts.length > 0) {

        html += `

          <div
            class="kb-hidden-products"
            id="hidden-${index}"
            style="display:none;"
          >

        `;

        hiddenProducts.forEach(product => {

          html += renderCard(product);

        });

        html += `
          </div>

          <button
            class="kb-show-more-btn"
            data-target="hidden-${index}"
          >

            Show More Products

          </button>

        `;

      }

      html += `

          </div>

        </div>

      `;

    });

    resultsContainer.innerHTML = html;

    resultsContainer.classList.remove('loading');

resultsContainer.classList.add('ready');

  }

  /* ===================================
     CARD
  =================================== */

  function renderCard(product) {

    return `

      <a
        href="${product.url}"
        class="kb-tech-card"
      >

        <div class="kb-tech-card-image">

          <img
            src="${product.image}"
            alt="${product.title}"
            loading="lazy"
          >

        </div>

        <div class="kb-tech-card-content">

          <h3>
            ${product.title}
          </h3>

          <div class="kb-tech-subtitle">
            View Product
          </div>

        </div>

      </a>

    `;

  }

  /* ===================================
     SHOW MORE
  =================================== */

  document.addEventListener('click', function (e) {

    if (
      e.target.classList.contains(
        'kb-show-more-btn'
      )
    ) {

      const target =
        document.getElementById(
          e.target.dataset.target
        );

      if (target.style.display === 'none') {

        target.style.display = 'flex';
        target.style.flexDirection = 'column';
        target.style.gap = '10px';

        e.target.innerText =
          'Show Less';

      } else {

        target.style.display = 'none';

        e.target.innerText =
          'Show More Products';

      }

    }

  });

  /* ===================================
     SEARCH SUGGESTIONS
  =================================== */

  function renderSuggestions(groups) {

    if (!groups.length) {

      suggestionsContainer
        .classList.remove('active');

      return;

    }

    suggestionsContainer.innerHTML =
      groups
        .slice(0, 6)
        .map(group => `

          <div
            class="kb-tech-suggestion-item"
            data-name="${group.technicalName}"
          >

            ${group.technicalName}

          </div>

        `)
        .join('');

    suggestionsContainer
      .classList.add('active');

  }

  /* ===================================
     SEARCH
  =================================== */
searchInput.addEventListener('input', function () {

  const value =
    this.value.toLowerCase().trim();

  alphabetButtons.forEach(btn =>
    btn.classList.remove('active')
  );

  /* EMPTY */

  if (!value) {

    suggestionsContainer.innerHTML = '';

    suggestionsContainer.classList.remove('active');

    resultsContainer.innerHTML = `
      <div class="kb-empty-state">
        Technical products will appear here
      </div>
    `;

    return;

  }

  /* SUGGESTIONS */

  const suggestions =
    allProducts.filter(group =>
      group.technicalName
        .toLowerCase()
        .includes(value)
    ).slice(0, 8);

  if (suggestions.length) {

    suggestionsContainer.innerHTML =
      suggestions.map(item => `

        <div
          class="kb-tech-suggestion-item"
          data-name="${item.technicalName}"
        >

          ${item.technicalName}

        </div>

      `).join('');

    suggestionsContainer.classList.add('active');

  } else {

    suggestionsContainer.innerHTML = '';

    suggestionsContainer.classList.remove('active');

  }

  /* RESULTS */

  const filtered =
    allProducts.filter(group =>
      group.technicalName
        .toLowerCase()
        .includes(value)
    );

  renderProducts(filtered);

});

  /* ===================================
     SUGGESTION CLICK
  =================================== */

  document.addEventListener('click', function (e) {

    if (
      e.target.classList.contains(
        'kb-tech-suggestion-item'
      )
    ) {

      const selected =
        e.target.dataset.name;

      searchInput.value =
        selected;

      const filtered =
        allProducts.filter(group =>
          group.technicalName === selected
        );

      renderProducts(filtered);

      suggestionsContainer
        .classList.remove('active');

    }

  });

  /* ===================================
     ALPHABET FILTER
  =================================== */

  alphabetButtons.forEach(button => {

    button.addEventListener('click', function () {

      const letter =
        this.textContent
          .trim()
          .toLowerCase();

      alphabetButtons.forEach(btn =>
        btn.classList.remove('active')
      );

      this.classList.add('active');

      const filtered =
        allProducts.filter(group =>
          group.technicalName
            .toLowerCase()
            .startsWith(letter)
        );

      renderProducts(filtered);

      /* AUTO SCROLL */

setTimeout(() => {

  resultsContainer.scrollIntoView({

    behavior:'smooth',
    block:'start'

  });

}, 120);

    });

  });

  /* ===================================
     INIT
  =================================== */
  fetch('/products.json?limit=1')
.then(r => r.json())
.then(data => {
  console.log('PRODUCT API WORKING');
  console.log(data);
});
  loadProducts();

});

/* ===================================
SUGGESTION CLICK
=================================== */

document.addEventListener('click', function(e){

  const item =
    e.target.closest('.kb-tech-suggestion-item');

  if(item){

    const value =
      item.dataset.name;

    searchInput.value = value;

    suggestionsContainer.classList.remove('active');

    const filtered =
      allProducts.filter(group =>
        group.technicalName === value
      );

    renderProducts(filtered);

    setTimeout(() => {

  resultsContainer.scrollIntoView({

    behavior:'smooth',
    block:'start'

  });

}, 120);

    resultsContainer.scrollIntoView({
      behavior:'smooth'
    });

  }

});

/* ===================================
OUTSIDE CLICK
=================================== */

document.addEventListener('click', function(e){

  if(
    !e.target.closest('.kb-tech-search')
  ){

    suggestionsContainer.classList.remove('active');

  }

});

